import React from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./Redux/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { SessionProvider } from "./Context/SessionContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
import { SubscriptionProvider } from "./Context/SubscriptionContext";
import { WhatsappProvider } from "./Context/WhatsappContext";
import { ThemeContextProvider } from "./Context/ThemeContext/ThemeContext";
root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeContextProvider>
          <SubscriptionProvider>
            <SessionProvider>
              <WhatsappProvider>
                <App />
              </WhatsappProvider>
            </SessionProvider>
          </SubscriptionProvider>
        </ThemeContextProvider>
      </Provider>
    </BrowserRouter>
  </StyledEngineProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
